export default {
  zh: {
    descriptions: {
      groups: '分组列',
      others: '其他列',
      aggregates: '聚合列',
    },
    tips: {
      aggregates: '以摘要的形式收集并展示原始数据。',
    },
    actions: {
      day: '按天分组',
      week: '按周分组',
      month: '按月分组',
      quarter: '按季度分组',
      year: '按年分组',
      sum: '和',
      avg: '平均数',
    },
    modals: {
      groups: '分组设置',
      aggregates: '聚合设置',
    },
    sort: '排序',
    sortTitle: '排序{num}',
  },
  en: {
    descriptions: {
      groups: 'Groups Zone',
      others: 'Others Zone',
      aggregates: 'Aggregates Zone',
    },
    tips: {
      aggregates: 'Gathered and expressed raw data in a summary form.',
    },
    actions: {
      day: 'Group By Day',
      week: 'Group By Week',
      month: 'Group By Month',
      quarter: 'Group By Quarter',
      year: 'Group By Year',
      sum: 'Sum',
      avg: 'Avg',
    },
    modals: {
      groups: 'Group By',
      aggregates: 'Aggregate By',
    },
    sort: 'Sort',
    sortTitle: 'Sort {num}',
  },
};



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/i18n.js